import uuid from 'node-uuid';

export const formatAddSinglePayment = (selectedPayeeId, reference) => ({
	id: uuid.v1(),
	fromAccount: selectedPayeeId,
	reference,
});
